/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 *
 * @export
 * @interface NewShopForMeRequest
 */
export interface NewShopForMeRequest {
  /**
   *
   * @type {number}
   * @memberof NewShopForMeRequest
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof NewShopForMeRequest
   */
  customerId?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  status?: string;
  /**
   *
   * @type {number}
   * @memberof NewShopForMeRequest
   */
  totalAmount?: number;
  /**
   *
   * @type {number}
   * @memberof NewShopForMeRequest
   */
  purchasingFee?: number;
  /**
   *
   * @type {number}
   * @memberof NewShopForMeRequest
   */
  grandTotal?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  adminNotes?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  paymentStatus?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  paymentReference?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopForMeRequest
   */
  proofOfPayment?: string;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  quoteExpiresAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  quotedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  confirmedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  paidAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopForMeRequest
   */
  updatedAt?: Date;
}

/**
 * Check if a given object implements the NewShopForMeRequest interface.
 */
export function instanceOfNewShopForMeRequest(
  value: object
): value is NewShopForMeRequest {
  return true;
}

export function NewShopForMeRequestFromJSON(json: any): NewShopForMeRequest {
  return NewShopForMeRequestFromJSONTyped(json, false);
}

export function NewShopForMeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewShopForMeRequest {
  if (json == null) {
    return json;
  }
  return {
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    status: json['status'] == null ? undefined : json['status'],
    totalAmount: json['totalAmount'] == null ? undefined : json['totalAmount'],
    purchasingFee: json['purchasingFee'] == null ? undefined : json['purchasingFee'],
    grandTotal: json['grandTotal'] == null ? undefined : json['grandTotal'],
    currency: json['currency'] == null ? undefined : json['currency'],
    notes: json['notes'] == null ? undefined : json['notes'],
    adminNotes: json['adminNotes'] == null ? undefined : json['adminNotes'],
    paymentMethod: json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    paymentStatus: json['paymentStatus'] == null ? undefined : json['paymentStatus'],
    paymentReference: json['paymentReference'] == null ? undefined : json['paymentReference'],
    proofOfPayment: json['proofOfPayment'] == null ? undefined : json['proofOfPayment'],
    quoteExpiresAt: json['quoteExpiresAt'] == null ? undefined : new Date(json['quoteExpiresAt']),
    quotedAt: json['quotedAt'] == null ? undefined : new Date(json['quotedAt']),
    confirmedAt: json['confirmedAt'] == null ? undefined : new Date(json['confirmedAt']),
    paidAt: json['paidAt'] == null ? undefined : new Date(json['paidAt']),
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
  };
}

export function NewShopForMeRequestToJSON(json: any): NewShopForMeRequest {
  return NewShopForMeRequestToJSONTyped(json, false);
}

export function NewShopForMeRequestToJSONTyped(
  value?: NewShopForMeRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    courierId: value['courierId'],
    customerId: value['customerId'],
    status: value['status'],
    totalAmount: value['totalAmount'],
    purchasingFee: value['purchasingFee'],
    grandTotal: value['grandTotal'],
    currency: value['currency'],
    notes: value['notes'],
    adminNotes: value['adminNotes'],
    paymentMethod: value['paymentMethod'],
    paymentStatus: value['paymentStatus'],
    paymentReference: value['paymentReference'],
    proofOfPayment: value['proofOfPayment'],
    quoteExpiresAt: value['quoteExpiresAt'] == null ? undefined : value['quoteExpiresAt'].toISOString(),
    quotedAt: value['quotedAt'] == null ? undefined : value['quotedAt'].toISOString(),
    confirmedAt: value['confirmedAt'] == null ? undefined : value['confirmedAt'].toISOString(),
    paidAt: value['paidAt'] == null ? undefined : value['paidAt'].toISOString(),
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
  };
}
